<template>
  <v-select
    class="font-weight-medium"
    title="Any"
    v-model="selectedData"
    :items="props.propsData"
    density="compact"
    variant="outlined"
    item-title="name"
    :label="props.boxName"
    item-value="id"
    @update:modelValue="clickHandler"
    persistent-hint
    multiple
  >
    <template v-slot:prepend-item>
      <div v-if="props.propsData !== undefined && props.propsData.length !== 0">
        <v-list-item title="Select All" @click="toggle">
          <template v-slot:prepend>
            <v-checkbox-btn
              :color="'indigo-darken-4'"
              :indeterminate="SomeItems && !AllItems"
              :model-value="selectSubCatAllFlag"
            ></v-checkbox-btn>
          </template>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </div>
    </template>
    <template v-slot:selection="{ item, index }">
      <v-chip v-if="index < 2">
        <span>{{ item.title }}</span>
      </v-chip>
      <span v-if="index === 2" class="text-grey text-caption align-self-center">
        (+{{ selectedData.length - 2 }} others)
      </span>
    </template>
  </v-select>
</template>
<script setup>
import { defineProps, ref, watchEffect } from "vue";
import { useStore } from "vuex";

const store = useStore();

const props = defineProps({
  propsData: {
    type: Array,
    default: () => [{ sectorID: 0, sectorName: "Any" }],
  },
  boxName: {
    type: String,
  },
});

const selectedData = ref([]);
const disSelect = ref();
const offerOrigin = ref(store.getters["Sector/getOfferOrigin"]);
const previousSelectedStructures = ref([]);
// const clearable = ref();
const selectedID = ref();
const view = ref([]);
const selectSubCatAllFlag = ref(false);
// console.log(selectSubCatAllFlag.value, "selectSubCatAllFlag");
watchEffect(() => {
  // clearable.value = store.getters["Sector/getcategoryFieldsCleaningGetter"];
  // let cat = store.getters["Sector/getcategorySector"];
  //   let subcat = store.getters["Sector/getSubCategoryGetters"];
  // let subcatSelected = store.getters["Sector/getSubCategorySelectedGetters"];
  // console.log(
  //   store.getters["Sector/getSubCategorySelectedGetters"],
  //   "selectedgetters"
  // );
  // selectSubCatAllFlag.value = store.getters["Sector/getselectSubCatAllFlagGetters"];
  selectedData.value = store.getters["Sector/getSubCategorySelectedGetters"];
  if (
    props.propsData !== undefined &&
    props.propsData !== null &&
    selectedData.value !== undefined &&
    selectedData.value !== null
  ) {
    // let flag = store.getters["Sector/getLastSearchActivatedGetters"];
    if (
      Object.keys(props.propsData).length ===
      Object.keys(selectedData.value).length
    ) {
      // toggle();
      selectSubCatAllFlag.value = true;
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
    } else {
      selectSubCatAllFlag.value = false;
      selectedData.value.forEach((t) => {
        view.value.push(t.id);
      });
      // let temp = [];
      // selectedData.value.forEach((t) => {
      //   temp.push(t.id);
      // });
      // clickHandler(temp);
    }
  }
});

function toggle() {
  if (selectSubCatAllFlag.value === false) {
    selectSubCatAllFlag.value = true;
  } else {
    selectSubCatAllFlag.value = false;
  }
  disSelect.value = null;
  if (selectSubCatAllFlag.value) {
    selectedData.value = [];
    selectedData.value = props.propsData;
    store.dispatch("Sector/setsubcategorySelectedAct", props.propsData);
    // if (props.boxName === "Category") {
    //   selectedData.value.forEach((i) => {
    //     switchSubCategoryFunctionCases(i.sectorID, i.sectorName);
    //   });
    // } else if (props.boxName === "Sub Category") {
    if (selectedData.value !== undefined) {
      selectedData.value.forEach((i) => {
        view.value.push(i.id);
        let catPayload = store.getters["Sector/getcategoryPayload"];
        offerOriginFn(i.id, "add");
        Object.keys(catPayload).find((key) => {
          if (key === "cat_sub") {
            if (!catPayload[key].includes(i.id)) {
              store.dispatch("Sector/setsubcategoryPayloadAct", i.id);
              // state.categoryPayload[key].push(i.sectorID);
              // }
            }
          }
        });
        sectorsFnHandler(i.id, "Sector/setSubSubCategoryAction");
      });
      const searchCry = {
        val: view.value,
        column: props.boxName,
        entirs: props.propsData,
      };
      store.dispatch("Rawdata/setSearchCritertia", searchCry);
    }
    //}
    //else if (props.boxName === "Sub Sub Category") {
    // selectedData.value.forEach((i) => {
    //   switchSubCategoryFunctionCases(i.sectorID, i.sectorName);
    // });
    //}
  } else {
    // offerOriginFn(0, "all");
    selectedData.value.forEach((i) => {
      categoryDisSelectionHandler(i.id);
      offerOriginFn(i.id, "delete");
    });
    selectedData.value = [];
    store.dispatch("Sector/setsubcategorySelectedAct", selectedData.value);
  }
}

function offerOriginFn(id, dis) {
  // console.log(id, dis);
  let obj = store.getters["Rawdata/getofferOriginChanged"];
  if (dis === "add") {
    for (let i = 0; i < obj.length; i++) {
      let sectors = obj[i].oo_sectorID;
      if (sectors.includes(id)) {
        // Check for duplicates before pushing
        let found = offerOrigin.value.some(
          (item) => item.oo_id === obj[i].oo_id
        );
        if (!found) {
          offerOrigin.value.push(obj[i]);
        }
      }
    }
  } else if (dis === "delete") {
    // If 'delete' parameter is passed, remove the object from the offerOrigin.value array
    for (let i = 0; i < offerOrigin.value.length; i++) {
      let sectors = offerOrigin.value[i].oo_sectorID;
      if (sectors.includes(id)) {
        // Use splice to remove the item from array by index
        offerOrigin.value.splice(i, 1);
        i--; // Decrement index after removal to avoid skipping elements
      }
    }
  } else if (dis === "all") {
    offerOrigin.value = [];
  }
  store.dispatch("Sector/setOfferOrigin", offerOrigin.value);
}
function clickHandler(e) {
  // console.log(12, e);
  // console.log(selectedData.value, "selec");
  // console.log(props.boxName);
  store.dispatch("Sector/setLastSearchActivated", false);
  let catsubData = store.getters["Sector/getSubCategoryGetters"];
  let subcatSelectedRec = [];
  const searchCry = {
    val: e,
    column: props.boxName,
    entirs: props.propsData,
  };
  store.dispatch("Rawdata/setSearchCritertia", searchCry);
  // console.log(catsubData, "catsubData");
  catsubData.forEach((i) => {
    let found = e.includes(i.id);
    if (found) {
      subcatSelectedRec.push(i);
    }
  });
  // console.log(subcatSelectedRec, "catSelect");
  store.dispatch("Sector/setsubcategorySelectedAct", subcatSelectedRec);
  if (props.boxName == "Sub Category") {
    let checkboxSelected = JSON.parse(JSON.stringify(view.value));
    // console.log(checkboxSelected, "vuiew");
    // console.log(checkboxSelected.length, "len");
    // console.log(view.value, "view");
    disSelect.value = null;
    selectedID.value = null;
    if (e.length >= view.value.length) {
      if (e.length != 0 && e !== undefined) {
        for (let i of e) {
          let found = !JSON.parse(JSON.stringify(checkboxSelected)).includes(i);
          if (found) {
            selectedID.value = i;
          } else {
            selectedID.value = i;
          }
          // this one will show further value in offer origin if 14 is selected
          offerOriginFn(selectedID.value, "add");
        }
        view.value = e;
      }
    } else {
      if (view.value.length != 0 && view.value !== undefined) {
        for (let i of view.value) {
          let found = !JSON.parse(JSON.stringify(e)).includes(i);
          if (found) {
            disSelect.value = i;
            // this one will show further value in offer origin if 14 is selected
            offerOriginFn(i, "delete");
          }
        }
        view.value = e;
      }
    }
    if (disSelect.value) {
      categoryDisSelectionHandler(disSelect.value);
    } else {
      sectorsFnHandler(selectedID.value, "Sector/setSubSubCategoryAction");
    }
    // let count = e.length;
    // if (count > 0) {
    //   sectorsFnHandler(e[count - 1].id, "Sector/setSubSubCategoryAction");
    // }
    let catPayload = store.getters["Sector/getcategoryPayload"];
    // console.log(catPayload, "catPayload");
    Object.keys(catPayload).find((key) => {
      if (key === "cat_sub") {
        e.forEach((i) => {
          // const index = catPayload[key].indexOf(i.sectorID);
          // console.log(i, "i");
          // if (index === -1) {
          if (!catPayload[key].includes(i)) {
            store.dispatch("Sector/setsubcategoryPayloadAct", i);
            // state.categoryPayload[key].push(i.sectorID);
            // }
          }
        });
      }
    });
    // store.dispatch("Sector/setsubcategorySelectedAct", e);
  }
  //  else if (props.boxName == "Sub Sub Category") {
  //   store.dispatch("Sector/setsubsubcategoryPayloadAct", e);
  // }
  let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
  let ridersDataNames = [];
  // console.log("3data", ridersOriginal, e);
  if (e.length > 0) {
    // console.log(11, e[0].sectorID);
    for (let i = 0; i < ridersOriginal.length; i++) {
      let secidArray = ridersOriginal[i].riders_sectorID
        .split(",")
        .map((id) => id.trim());
      let status = !secidArray.includes(e.toString());
      if (!status) {
        ridersDataNames.push(ridersOriginal[i]);
      }
    }
  }
  // console.log("ridersDataNames", ridersDataNames);
  store.dispatch("Sector/setSectorIdsRiders", ridersDataNames);

  let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
  let issueDataNames = [];
  if (e.length > 0) {
    // console.log(11, e[0].sectorID);
    for (let i = 0; i < issuesOriginal.length; i++) {
      let secidArray = issuesOriginal[i].sector_id
        .split(",")
        .map((id) => id.trim());
      let status = secidArray.includes(e.toString());
      if (status) {
        issueDataNames.push(issuesOriginal[i]);
      }
    }
  }
  // console.log(issueDataNames, "issueDataNames");
  store.dispatch("Sector/setIssueTypeData", issueDataNames);

  disSelect.value = previousSelectedStructures.value.filter(
    (item) => !e.includes(item)
  );
  // console.log("diselect", disSelect.value);

  // previousSelectedStructures.value = e;
  // let count = e.length;
  // // console.log("count len", count);
  // if (count >= 0) {
  //   // console.log(e[count - 1].sectorID);
  //   // console.log("diselect len", disSelect.value.length);
  //   if (disSelect.value.length >= 1) {
  //     // console.log(disSelect.value[0].sectorID);
  //     categoryDisSelectionHandler(disSelect.value[0].id);
  //   }
  //   // else {
  //   //   //the below function executes when user add option in the dropdown
  //   //   switchSubCategoryFunctionCases(
  //   //     e[count - 1].sectorID,
  //   //     e[count - 1].sectorName
  //   //   );
  //   // }
  // }
}

function categoryDisSelectionHandler(disid) {
  // alert("disfn clicked");
  // console.log("dis", disid);
  // store.dispatch("Sector/setunCheckSubcategoryPayloadAct", disid);
  // let subCatData = store.getters["Sector/getSubCategoryGetters"];
  store.dispatch("Sector/setunCheckSubcategoryPayloadAct", disid);
  let subsubCatData = store.getters["Sector/getSubSubCategoryGetters"];
  let subsubCatSelectedData =
    store.getters["Sector/getsubSubCategorySelectedGetters"];
  // console.log(subCatData);
  // let count = 0;
  // for (const i in subCatData) {
  //   if (subCatData[i].id === disid) {
  //     count++;
  //   }
  // }

  // for (const i in subCatData) {
  //   if (subCatData[i].id === disid) {
  //     subCatData.splice(i, count);
  //     store.dispatch("Sector/setSubCategoryAction", subCatData);
  //   }
  // }

  // let subsubcount = 0;
  // for (const i in subsubCatData) {
  //   if (subsubCatData[i].id === disid) {
  //     subsubcount++;
  //   }
  // }
  // for (const i in subsubCatData) {
  //   if (subsubCatData[i].id === disid) {
  //     subsubCatData.splice(i, subsubcount);
  //     store.dispatch("Sector/setSubSubCategoryAction", subsubCatData);
  //   }
  // }
  let filteredSubsubCat = subsubCatData.filter((f) => f.subsubpid !== disid);
  // console.log(filteredSubsubCat, "filteredSubsubCat");
  store.dispatch("Sector/setSubSubCategoryAction", filteredSubsubCat);
  let filteredSubsubCatSel = subsubCatSelectedData.filter(
    (f) => f.subsubpid !== disid
  );
  // console.log(filteredSubsubCatSel, "filteredSubsubCatSel");
  store.dispatch("Sector/setsubsubcategorySelectedAct", filteredSubsubCatSel);

  // let subsubSelectedcount = 0;
  // for (const i in subsubCatSelectedData) {
  //   if (subsubCatSelectedData[i].id === disid) {
  //     subsubSelectedcount++;
  //   }
  // }
  // for (const i in subsubCatSelectedData) {
  //   if (subsubCatSelectedData[i].id === disid) {
  //     subsubCatSelectedData.splice(i, subsubSelectedcount);
  //     store.dispatch(
  //       "Sector/setsubsubcategorySelectedAct",
  //       subsubCatSelectedData
  //     );
  //   }
  // }

  // rider data
  let ridersOriginal = store.getters["Rawdata/getDropdownDataAPI"].riders;
  for (let i = 0; i < ridersOriginal.length; i++) {
    let secidArray = ridersOriginal[i].riders_sectorID
      .split(",")
      .map((id) => id.trim());
    let status = secidArray.includes(disid.toString());
    if (status) {
      ridersOriginal.slice(i, 1);
    }
  }
  if (disid == 13) {
    store.dispatch("Sector/setSectorFaceAmtData", [{ fa_name: "Any" }]);
  }

  // issue type data
  let issuesOriginal = store.getters["Rawdata/getDropdownDataAPI"].issue;
  for (let i = 0; i < issuesOriginal.length; i++) {
    let secidArray = issuesOriginal[i].sector_id
      .split(",")
      .map((id) => id.trim());
    let status = secidArray.includes(disid.toString());
    if (status) {
      issuesOriginal.slice(i, 1);
    }
  }
  if (disid == 13) {
    store.dispatch("Sector/setIssueTypeData", [{ IssueTypeName: "Any" }]);
  }
}

function sectorsFnHandler(id, actionName) {
  // console.log(id, actionName);
  let subsubcat = store.getters["Sector/getAllSubSubCategoryLocalGetters"];
  let showsubsubcatstore = store.getters["Sector/getSubSubCategoryGetters"];
  let faceOriginal = store.getters["Rawdata/getDropdownDataAPI"].faceamount;
  let faceamount = store.getters["Sector/getsectorFaceAmtDataGett"];
  // console.log(subsubcat, "subsubcat");
  // let storeData = store.getters["Sector/getcategorySector"];

  let uniqueValues = new Set();
  let catnameIsSelected = 0;
  // console.log(props.propsData, "props");
  props.propsData.forEach((p) => {
    if (p.id === id) {
      let strSlicedIndexValue = p.name.search(" >> ");
      catnameIsSelected = p.name.slice(strSlicedIndexValue + 4, p.name.length); // this is removing parent name and adding only subparent name
    }
  });
  // Filter unique values from 'cat' array based on the condition
  // eslint-disable-next-line no-unused-vars
  Object.entries(subsubcat).forEach(([key, value]) => {
    // console.log(key, "key");
    if (value.subsubpid === id) {
      uniqueValues.add(value);
    }
  });
  if (faceamount.length == 0) {
    store.dispatch("Sector/setSectorFaceAmtData", faceOriginal);
  }

  // Filter unique values from 'showcatstore' array
  showsubsubcatstore.forEach((t) => {
    uniqueValues.add(t);
  });
  // console.log(catnameIsSelected, "cat");
  // Convert the Set back to an array ('showcat') to match your original data structure
  let showsubcat = [...uniqueValues];
  showsubcat.forEach((p) => {
    let arrowFlag = p.name.includes(" >> ");
    // console.log(p.name);
    // console.log(catnameIsSelected, "cat");
    if (!arrowFlag) {
      // console.log(p.name.slice(0, p.name.search(" >> ")), "sliced");
      let temp = catnameIsSelected + " >> " + p.name; //this is adding subparent name with children names
      // console.log(temp, "temp");
      p.name = temp;
    }

    // }
  });
  // console.log(showsubcat, "showsubcat");
  store.dispatch(actionName, showsubcat);
}

// a
</script>
<style scoped>
#mySelect .v-select .dropdown-toggle {
  color: red;
}
</style>
